import { mapEnumToOptions } from '@abp/ng.core';

export enum CouponStatus {
  Pending = 0,
  Active = 1,
  Expired = 2,
  Deactivated = 3,
  Inactive = 4,
}

export const couponStatusOptions = mapEnumToOptions(CouponStatus);
